const cdn = require('./cdn/index')
const utils = require('./utils/index')
const cloud = require('./utils/cloud')
const request = require('./request/index')
const extendApp = require('./extend/index')

module.exports = {
    cdn,
    utils,
    cloud,
    request,
    extendApp
}
